import React, { useState } from 'react'
import styled from 'submodules/nerit-framework-ui/theme/_old/styledWithTheme'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { LoginFormModel } from 'app/components/form-login/form-model/LoginFormModel'
import { RecoverAccessFormModel } from 'app/components/form-login/form-model/RecoverAccessFormModel'
import { FormLoginDataICP } from 'app/components/form-login/inner/FormLoginDataICP'
import { FormRecoverAccessICP } from 'app/components/form-login/inner/FormRecoverAccessICP'
import {LOGIN_VIEW_SECTION_ORDER, LOGIN_WELCOME_TITLE_EMPHASIS, LOGIN_WELCOME_TITLE_PREFIX} from 'app/components/form-login/inner/loginFormFeedback'

export function FormLoginCP(): JSX.Element {

	const [view, setView] = useState<'recoverPassword' | 'login'>('login')

	const [loginFormModel] = useState<LoginFormModel>(
		new LoginFormModel()
	)

	const [recoverAccessFormModel] = useState<RecoverAccessFormModel>(
		new RecoverAccessFormModel()
	)

	const loginFormStateManager = useFormStateManager(loginFormModel)
	const recoverAccessFormStateManager = useFormStateManager(recoverAccessFormModel)

	return (
		<FormContainerSCP>
			<FormTitleSCP data-login-section={LOGIN_VIEW_SECTION_ORDER[0]}>
				{LOGIN_WELCOME_TITLE_PREFIX}
				{' '}
				<b>
					{LOGIN_WELCOME_TITLE_EMPHASIS}
				</b>
			</FormTitleSCP>

			{
				view === 'login' &&
					<FormLoginDataICP
						formStateManager={loginFormStateManager}
						onResetPassword={() => setView('recoverPassword')}
					/>
			}

			{
				view === 'recoverPassword' &&
					<FormRecoverAccessICP
						formStateManager={recoverAccessFormStateManager}
						onBack={() => setView('login')}
					/>
			}
		</FormContainerSCP>
	)
}

const FormContainerSCP = styled.div`
	width: 100%;
	max-width: 365px;
	height: 100%;
	margin-top: 30px;
`

const FormTitleSCP = styled.span`
	margin-bottom: 40px;
	display: flex;
	justify-content: center;

	b {
		margin-left: 5px;
	}
`